import { useState } from 'react';

const fanbirdLogo: string = require('../../Image/Logo.png');

type Props = { src?: string; alt: string; className?: string };

export default function ProductThumbnail({ src, alt, className }: Props) {
  const [failedSrc, setFailedSrc] = useState<string>();
  const fallback = !src || src === failedSrc;
  return <img
    className={className}
    src={fallback ? fanbirdLogo : src}
    alt={fallback ? `${alt} - 팬버드 로고` : alt}
    style={{ objectFit: fallback ? 'contain' : 'cover', backgroundColor: '#fff' }}
    onError={() => { if (!fallback) setFailedSrc(src); }}
  />;
}
